// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shell-module__root--JZLOb {
  box-sizing: border-box;
}

.Shell-module__ui-Shell--eYWTI {
  display: flex;
  align-items: center;
  width: 100%;
}

.Shell-module__size-medium--jc_t5 {
  --shell-leading-gap: 11px;
  --shell-content-gap: 2px;
  --shell-title-font-size: 13px;
  --shell-title-line-height: 19.5px;
  --shell-title-letter-spacing: -0.4262px;
  --shell-content-color: var(--chaek-color-text-muted);
  --shell-content-white-space: nowrap;
  --shell-content-word-break: normal;
}

.Shell-module__size-small--k_guT {
  --shell-leading-gap: 10px;
  --shell-content-gap: 1px;
  --shell-title-font-size: 10px;
  --shell-title-line-height: 16px;
  --shell-title-letter-spacing: -0.2328px;
  --shell-content-color: var(--chaek-color-text-secondary);
  --shell-content-white-space: normal;
  --shell-content-word-break: break-word;
}

.Shell-module__ui-Shell-Leading--vmele {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-right: var(--shell-leading-gap);
}

.Shell-module__ui-Shell-Content--OtcP9 {
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  gap: var(--shell-content-gap);
  word-break: var(--shell-content-word-break);
  white-space: pre-wrap;
}

.Shell-module__ui-Shell--eYWTI.Shell-module__vertical-align-top--lMsRJ {
  align-items: flex-start;
}

.Shell-module__ui-Shell--eYWTI.Shell-module__vertical-align-center--Fz_kM {
  align-items: center;
}

.Shell-module__ui-Shell--eYWTI.Shell-module__vertical-align-bottom--ddvDn {
  align-items: flex-end;
}

.Shell-module__ui-Shell-Content--OtcP9.Shell-module__vertical-align-top--lMsRJ {
  justify-content: flex-start;
}

.Shell-module__ui-Shell-Content--OtcP9.Shell-module__vertical-align-center--Fz_kM {
  justify-content: center;
}

.Shell-module__ui-Shell-Content--OtcP9.Shell-module__vertical-align-bottom--ddvDn {
  justify-content: flex-end;
}

.Shell-module__title--jApFl {
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: var(--shell-title-font-size);
  font-weight: 400;
  line-height: var(--shell-title-line-height);
  letter-spacing: var(--shell-title-letter-spacing);
  white-space: nowrap;
}

.Shell-module__content--kNWmB {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--shell-content-color);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.2328px;
  white-space: var(--shell-content-white-space);

  width: 100%;
}

.Shell-module__description--Ck1lW {
  color: var(--chaek-color-text-muted);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.2328px;
}

.Shell-module__ui-Shell-Trailing--Igc8U {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: auto;
  text-align: right;
}
.Shell-module__is-reverse--yj6hN {
  color: #ffffff;
}

.Shell-module__is-reverse--yj6hN .Shell-module__title--jApFl {
  color: #ffffff;
}

.Shell-module__is-reverse--yj6hN .Shell-module__content--kNWmB {
  color: #999999;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Shell/Shell.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,iCAAiC;EACjC,uCAAuC;EACvC,oDAAoD;EACpD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,uCAAuC;EACvC,wDAAwD;EACxD,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,iDAAiD;EACjD,uCAAuC;EACvC,gBAAgB;EAChB,2CAA2C;EAC3C,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;;EAE7C,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".root {\n  box-sizing: border-box;\n}\n\n.ui-Shell {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.size-medium {\n  --shell-leading-gap: 11px;\n  --shell-content-gap: 2px;\n  --shell-title-font-size: 13px;\n  --shell-title-line-height: 19.5px;\n  --shell-title-letter-spacing: -0.4262px;\n  --shell-content-color: var(--chaek-color-text-muted);\n  --shell-content-white-space: nowrap;\n  --shell-content-word-break: normal;\n}\n\n.size-small {\n  --shell-leading-gap: 10px;\n  --shell-content-gap: 1px;\n  --shell-title-font-size: 10px;\n  --shell-title-line-height: 16px;\n  --shell-title-letter-spacing: -0.2328px;\n  --shell-content-color: var(--chaek-color-text-secondary);\n  --shell-content-white-space: normal;\n  --shell-content-word-break: break-word;\n}\n\n.ui-Shell-Leading {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding-right: var(--shell-leading-gap);\n}\n\n.ui-Shell-Content {\n  display: flex;\n  flex: 1 0 0;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  min-width: 0;\n  gap: var(--shell-content-gap);\n  word-break: var(--shell-content-word-break);\n  white-space: pre-wrap;\n}\n\n.ui-Shell.vertical-align-top {\n  align-items: flex-start;\n}\n\n.ui-Shell.vertical-align-center {\n  align-items: center;\n}\n\n.ui-Shell.vertical-align-bottom {\n  align-items: flex-end;\n}\n\n.ui-Shell-Content.vertical-align-top {\n  justify-content: flex-start;\n}\n\n.ui-Shell-Content.vertical-align-center {\n  justify-content: center;\n}\n\n.ui-Shell-Content.vertical-align-bottom {\n  justify-content: flex-end;\n}\n\n.title {\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: var(--shell-title-font-size);\n  font-weight: 400;\n  line-height: var(--shell-title-line-height);\n  letter-spacing: var(--shell-title-letter-spacing);\n  white-space: nowrap;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--shell-content-color);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: -0.2328px;\n  white-space: var(--shell-content-white-space);\n\n  width: 100%;\n}\n\n.description {\n  color: var(--chaek-color-text-muted);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: -0.2328px;\n}\n\n.ui-Shell-Trailing {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  text-align: right;\n}\n.is-reverse {\n  color: #ffffff;\n}\n\n.is-reverse .title {\n  color: #ffffff;\n}\n\n.is-reverse .content {\n  color: #999999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Shell-module__root--JZLOb`,
	"ui-Shell": `Shell-module__ui-Shell--eYWTI`,
	"size-medium": `Shell-module__size-medium--jc_t5`,
	"size-small": `Shell-module__size-small--k_guT`,
	"ui-Shell-Leading": `Shell-module__ui-Shell-Leading--vmele`,
	"ui-Shell-Content": `Shell-module__ui-Shell-Content--OtcP9`,
	"vertical-align-top": `Shell-module__vertical-align-top--lMsRJ`,
	"vertical-align-center": `Shell-module__vertical-align-center--Fz_kM`,
	"vertical-align-bottom": `Shell-module__vertical-align-bottom--ddvDn`,
	"title": `Shell-module__title--jApFl`,
	"content": `Shell-module__content--kNWmB`,
	"description": `Shell-module__description--Ck1lW`,
	"ui-Shell-Trailing": `Shell-module__ui-Shell-Trailing--Igc8U`,
	"is-reverse": `Shell-module__is-reverse--yj6hN`
};
export default ___CSS_LOADER_EXPORT___;
